export default __webpack_public_path__ + "media/allan.1fe3bc27.jpg";